/* eslint-disable no-plusplus */
const a11y = () => {
  const zoom = document.querySelector('.js-zoom');
  const contrast = document.querySelector('.js-contrast');
  const html = document.querySelector('html');
  const cookieObj = {
    set: (cname, cvalue, exdays) => {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    },
    get: cname => {
      const name = `${cname}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
  };
  if (cookieObj.get('a11y_zoom') && cookieObj.get('a11y_zoom') !== '') {
    html.classList.add(cookieObj.get('a11y_zoom'));
  }
  if (cookieObj.get('a11y_contrast') && cookieObj.get('a11y_contrast') !== '') {
    html.classList.add(cookieObj.get('a11y_contrast'));
  }

  zoom.addEventListener(
    'click',
    () => {
      if (html.classList.contains('is-zoomed')) {
        html.classList.remove('is-zoomed');
        html.classList.add('is-zoomed--2x');
        cookieObj.set('a11y_zoom', 'is-zoomed--2x', 1);
      } else if (html.classList.contains('is-zoomed--2x')) {
        html.classList.remove('is-zoomed--2x');
        cookieObj.set('a11y_zoom', '', 1);
      } else {
        html.classList.add('is-zoomed');
        cookieObj.set('a11y_zoom', 'is-zoomed', 1);
      }
    },
    true,
  );
  contrast.addEventListener(
    'click',
    () => {
      if (html.classList.contains('is-contrast')) {
        html.classList.remove('is-contrast');
        cookieObj.set('a11y_contrast', '', 1);
      } else {
        html.classList.add('is-contrast');
        cookieObj.set('a11y_contrast', 'is-contrast', 1);
      }
    },
    true,
  );
};

export default a11y;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/a11y.js